import { useCallback } from 'react';

export type ErrorDialogBoxProps = {
    errorMsg: string;
    isErrorDialogVisible: boolean;
    closeDialog: () => void;
};

export default function ErrorDialogBox({ errorMsg, isErrorDialogVisible, closeDialog }: ErrorDialogBoxProps) {
    const onOkClick = useCallback(() => {
        closeDialog();
    }, [closeDialog]);

    if (!isErrorDialogVisible) {
        return null;
    }

    return (
        <div className="container-fixed">
            <div className="sidePadding">
                <div className="row">
                    <div
                        id="simple-full-page-dialog-login"
                        className="comfirmation-sm-dialog"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="simple-full-page-dialog-title"
                    >
                        <section style={{ backgroundColor: '#fff', paddingTop: 10 }}>
                            <div className="row colMargin">
                                <div className="col-md-12" style={{ color: '#000' }}>
                                    <label>{errorMsg}</label>
                                </div>
                            </div>

                            <div className="row colMargin">
                                <div className="col-md-4"> </div>
                                <div className="col-md-8" style={{ padding: '0px' }}>
                                    <div className="row">
                                        <div className="col-md-12 alignEnd" style={{ paddingRight: 0 }}>
                                            <button type="button" className="btn btn-link" style={{ color: '#2f8428' }} onClick={onOkClick}>
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}
